const EXPAND_COLLAPSE_DURATION_MS = {
  enter: 250,
  exit: 100
};
const wrapperCls = "_61wsujnzw";
const subNavigationCls = "_61s1b0ogrx";
const focusOn = "_61f77x3g6";
const scrollWrapper = "_61siccbc";
const closeButtonCls = "_61cv4mdot";
const backdropCls = "_61b13dmb7i";

export { EXPAND_COLLAPSE_DURATION_MS, backdropCls, closeButtonCls, focusOn, scrollWrapper, subNavigationCls, wrapperCls };
import "./sub-navigation.mobile.style.linaria.module.css";
//# sourceMappingURL=sub-navigation.mobile.style.js.map
